__webpack_require__.p = "/frontend-rules/";